// @ts-nocheck

import { useCallback, useState } from 'react';

import Button from 'app/shared/core/Button';
import {
  ButtonFooter,
  ModalTitle,
  StyledRenterProfileForm,
  StyledRenterProfilePopup,
} from './PostContactRenterProfile.styles';

const PostContactRenterProfile = ({ onClose, onHidePopup = () => {} } = {}) => {
  const [shouldSaveData, setShouldSaveData] = useState(false);
  const [displaySavingMsg, setDisplaySavingMsg] = useState(false);

  /**
   * shouldSaveData is passed into the main renterProfileForm to trigger an
   * API call to save data, using the form's own handleSave method.
   * Once the API call is finished, hidePopupCallback is triggered
   * which automatically closes this form and continues the contact process.
   */
  const handleSaveClick = useCallback(() => {
    if (!shouldSaveData) {
      setDisplaySavingMsg(true);
      setShouldSaveData(true);
    }
  }, [shouldSaveData]);

  const hidePopupCallback = useCallback(() => {
    // Support both new modal manager (onClose) and legacy (onHidePopup)
    if (onClose) {
      onClose();
    } else {
      onHidePopup();
    }
  }, [onClose, onHidePopup]);

  const handleCancelClick = useCallback(() => {
    hidePopupCallback();
  }, [hidePopupCallback]);

  return (
    <StyledRenterProfilePopup>
      <ModalTitle htmlTag="div" id="dialog-title" className="PostContactSavedSearch-title" size="lg">
        Update your renter profile
      </ModalTitle>
      <StyledRenterProfileForm isPopup shouldSaveData={shouldSaveData} hidePopupCallback={hidePopupCallback} />
      <ButtonFooter>
        <Button full size="lg" btnType="text-color" onClick={handleSaveClick}>
          {displaySavingMsg ? 'Saving...' : 'Save'}
        </Button>
        <Button full size="lg" btnType="text-color-outline" onClick={handleCancelClick}>
          {'Cancel'}
        </Button>
      </ButtonFooter>
    </StyledRenterProfilePopup>
  );
};

export default PostContactRenterProfile;
